import { useEffect, useMemo } from "react";
import ReactGA from "react-ga4";
import { Divider, Typography } from "theme";

import { Box } from "@mui/material";

import { EquipmentKits } from "../../api/hooks/useEquipmentKits/type.ts";
import SelectedEquipment from "../../components/BookingDetails/SelectedEquipment.tsx";
import SelectedHall from "../../components/BookingDetails/SelectedHall.tsx";
import PersonalInfoForm from "../../components/Forms/PersonalInfoForm/PersonalInfoForm.tsx";
import { PrepaymentOptions } from "../../utils/constants/prepayment-options.ts";
import { REMINDER_OPTIONS } from "../../utils/constants/reminder-options.ts";

const BookingDetailPreview = () => {
  const defaultValues = useMemo(() => {
    const storageDate = localStorage.getItem("personalData");

    if (storageDate) {
      return {
        ...JSON.parse(storageDate),
        termsAccepted: false,
      };
    }

    return {
      phone: "",
      email: "",
      name: "",
      comment: "",
      reminder: REMINDER_OPTIONS[0].value,
      bookingPrepaymentValue: PrepaymentOptions.HALF,
      defaultEquipment: EquipmentKits.OneImpulseTwoConstant,
      termsAccepted: false,
    };
  }, []);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.href,
      title: "DETAILS_PREVIEW_PAGE",
    });
  }, []);

  return (
    <div>
      <Typography mb={2.5} variant="h2" textTransform="uppercase" weight="semiBold">
        Інформація про Оренду
      </Typography>
      <SelectedHall />

      <Box my={2.5}>
        <Divider />
      </Box>

      <SelectedEquipment />

      <PersonalInfoForm defaultValues={defaultValues} />
    </div>
  );
};

export default BookingDetailPreview;
